<ion-header>
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <ion-button mode="md" (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close" />
      </ion-button>
    </ion-buttons>
    <ion-title>B1 Debug</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list class="ion-no-padding">
    @if (!bluetoothEnabled()) {
      <ion-item (click)="enableBluetooth()" button>
        <ion-label>Enable bluetooth</ion-label>
      </ion-item>
    }

    @let deviceId = hardwareDevice()?.mac;

    @if (deviceId) {
      <ion-item-group class="ion-no-padding">
        <ion-item>
          <ion-label>{{ connected() ? 'Connected' : 'Disconnected' }}</ion-label>
          <ion-note style="font-size: 12px" slot="end">{{ hardwareDevice()?.name }}</ion-note>
        </ion-item>
        <ion-item>
          <ion-button slot="end" (click)="unpair(deviceId)" fill="outline" shape="round">
            <ion-label>Unpair</ion-label>
          </ion-button>
        </ion-item>
      </ion-item-group>
    } @else {
      <ion-item-group class="ion-no-padding">
        <ion-item (click)="scanAndPair()" button loader>
          <ion-label>Pair</ion-label>
        </ion-item>
        <ion-item (click)="fakePair()" button loader>
          <ion-label>Pair with fake thermometer</ion-label>
        </ion-item>
      </ion-item-group>
    }

    @if (deviceId) {
      <span>
        <ion-item-group>
          <ion-item-divider>
            <ion-label>Bluetooth</ion-label>
          </ion-item-divider>

          <ion-item (click)="readAllMeasurements()" button [disabled]="!connected()" loader>
            <ion-label>Read all measurements</ion-label>
          </ion-item>
          <ion-item (click)="readNewMeasurements()" button [disabled]="!connected()" loader>
            <ion-label>Read new measurements</ion-label>
          </ion-item>
          <ion-item (click)="clearAllMeasurements()" button>
            <ion-label>Clear all stashed measurements</ion-label>
          </ion-item>

          <ion-item (click)="readFirmwareVersion()" button [disabled]="!connected()" loader>
            <ion-label>Read firmware version</ion-label>
          </ion-item>
          <ion-item (click)="readSerialNumber()" button [disabled]="!connected()" loader>
            <ion-label>Read serial number</ion-label>
          </ion-item>

          <ion-item (click)="readDeviceStatus()" button [disabled]="!connected()" loader>
            <ion-label>Read device status</ion-label>
          </ion-item>
          <ion-item (click)="readErrorStatus()" button [disabled]="!connected()" loader>
            <ion-label>Read error status</ion-label>
          </ion-item>
          <ion-item (click)="readDiagnostics()" button [disabled]="!connected()" loader>
            <ion-label>Read diagnostics</ion-label>
          </ion-item>
        </ion-item-group>

        <ion-item-group>
          <ion-item (click)="factoryReset()" button [disabled]="!connected()">
            <ion-label>Factory reset</ion-label>
          </ion-item>
          <!-- TODO -->
          <!-- <ion-item (click)="performFOTA(id)" button>
            <ion-label>Perform FW update</ion-label>
          </ion-item>
          <ion-item (click)="cancelFOTA()" button>
            <ion-label>Cancel FW update</ion-label>
          </ion-item> -->
        </ion-item-group>
      </span>
    }

    <ion-item-group>
      <ion-list-header>
        <ion-label>Other</ion-label>
      </ion-list-header>

      <ion-item (click)="setBatteryStatus()" button>
        <ion-label>Set battery status</ion-label>
      </ion-item>

      <ion-item (click)="mockFirmwareVersion()" button>
        <ion-label>Mock firmware version in state</ion-label>
      </ion-item>

      <ion-item (click)="mockCriticalFWUpdate()" button>
        <ion-label>Mock critical FW update</ion-label>
      </ion-item>
    </ion-item-group>

    <ion-item-group class="ion-padding-horizontal">
      <ion-list-header>
        <ion-label>Logs</ion-label>
      </ion-list-header>

      @for (log of logs(); track log) {
        <span style="display: block">{{ log }}</span>
      }
    </ion-item-group>
  </ion-list>
</ion-content>
